// import homeThank from '../../components/home-thank';
// import homeSlider from '../../components/home-slider';
import homeSearch from '../../components/home-search';
import homeFindNearest from '../../components/home-find-nearest';
import circleScore from '../../components/circle-score';
// import animations from './home-page-animations';

export default function() {
  // homeThank();
  // homeSlider();
  homeSearch();
  homeFindNearest();
  circleScore();

  // animations
  //animations();
}
